import React, { useEffect, useState } from 'react';
import { MenuItem, Table, TableBody, TableCell, TableHead, TableRow, TextField, Typography } from '@mui/material';
import { Alert, Button, Card, CardContent, Container, Stack } from '../design-system';
import { getAdminUsers, updateAdminUserAccess } from '../services/adminUsersService';

export default function AdminUsersPage() {
  const [users, setUsers] = useState([]);
  const [drafts, setDrafts] = useState({});
  const [error, setError] = useState('');
  const [message, setMessage] = useState('');
  const [saving, setSaving] = useState(null);
  const load = async () => {
    try {
      const result = await getAdminUsers();
      setUsers(result);
      setDrafts(Object.fromEntries(result.map((user) => [user.id, { systemRole: user.system_role }])));
    } catch (loadError) { setError(loadError.message || 'No se pudieron cargar los usuarios.'); }
  };
  useEffect(() => { load(); }, []);
  const change = (userId, field, value) => setDrafts((current) => ({ ...current, [userId]: { ...current[userId], [field]: value } }));
  const save = async (user) => {
    const draft = drafts[user.id];
    setSaving(user.id);
    setError('');
    try {
      await updateAdminUserAccess({ userId: user.id, ...draft });
      setMessage(`Acceso actualizado para ${user.email}.`);
      await load();
    } catch (saveError) { setError(saveError.message || 'No se pudo actualizar el acceso.'); }
    finally { setSaving(null); }
  };
  return <Container className="wp-page" maxWidth="lg" sx={{ py: 5 }}>
    <Typography component="h1" variant="h4" fontWeight={800} gutterBottom>Usuarios y roles</Typography>
    <Typography color="text.secondary" sx={{ mb: 3 }}>El rol global concede acceso administrativo. El perfil de licencia se elige al contratar una licencia individual.</Typography>
    {error && <Alert severity="error" sx={{ mb: 2 }}>{error}</Alert>}
    {message && <Alert severity="success" sx={{ mb: 2 }}>{message}</Alert>}
    <Card><CardContent sx={{ overflowX: 'auto' }}>
      <Table>
        <TableHead><TableRow><TableCell>Usuario</TableCell><TableCell>Rol global</TableCell><TableCell /></TableRow></TableHead>
        <TableBody>{users.map((user) => {
          const draft = drafts[user.id] || {};
          return <TableRow key={user.id}>
            <TableCell><Stack spacing={0}><Typography fontWeight={700}>{user.full_name || 'Sin nombre'}</Typography><Typography variant="body2" color="text.secondary">{user.email}</Typography></Stack></TableCell>
            <TableCell><TextField select size="small" label={`Rol de ${user.email}`} value={draft.systemRole || 'user'} onChange={(event) => change(user.id, 'systemRole', event.target.value)}><MenuItem value="user">Usuario</MenuItem><MenuItem value="admin">Administrador</MenuItem></TextField></TableCell>
            <TableCell><Button size="small" variant="contained" onClick={() => save(user)} disabled={saving === user.id}>{saving === user.id ? 'Guardando...' : 'Guardar'}</Button></TableCell>
          </TableRow>;
        })}</TableBody>
      </Table>
    </CardContent></Card>
  </Container>;
}
